import api from 'api';

export const CUSTOMUOM_ASYNC_ACTION_START = 'CUSTOMUOM_ASYNC_ACTION_START';
export const CUSTOMUOM_ASYNC_CREATE_ACTION_SUCCESS = 'CUSTOMUOM_ASYNC_CREATE_ACTION_SUCCESS';
export const CUSTOMUOM_ASYNC_ACTION_SUCCESS = 'CUSTOMUOM_ASYNC_ACTION_SUCCESS';
export const CUSTOMUOM_COMMON_ASYNC_ACTION_SUCCESS = 'CUSTOMUOM_COMMON_ASYNC_ACTION_SUCCESS';
export const CUSTOMUOM_ASYNC_ACTION_ERROR = 'CUSTOMUOM_ASYNC_ACTION_ERROR';
export const CUSTOMUOM_RESET_STATE = 'CUSTOMUOM_RESET_STATE';

function customUomAsyncActionStart() {
  return {
    type: CUSTOMUOM_ASYNC_ACTION_START,
  };
}
function customUomCreateActionSuccess() {
  return {
    type: CUSTOMUOM_ASYNC_CREATE_ACTION_SUCCESS,
  };
}

function customUomAsyncActionSuccess(data) {
  return {
    type: CUSTOMUOM_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function loadCommonCustomUomAsyncActionSuccess(data) {
  return {
    type: CUSTOMUOM_COMMON_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function customUomAsyncActionError(error) {
  return {
    type: CUSTOMUOM_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetCustomUomState() {
  return {
    type: CUSTOMUOM_RESET_STATE,
  };
}

export function listCustomUomAsync() {
  return (dispatch, getState) => {
    dispatch(customUomAsyncActionStart());
    return api.request('customuom', 'get')
    .then((data) => {
      dispatch(customUomAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(customUomAsyncActionError('Unable to list customuom'));
      throw (err);
    });
  };
}

export function listCommonCustomUomAsync() {
  return (dispatch, getState) => {
    dispatch(customUomAsyncActionStart());
    return api.request('customuom/common', 'get')
    .then((data) => {
      dispatch(loadCommonCustomUomAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(customUomAsyncActionError('Unable to list customuom'));
      throw (err);
    });
  };
}

export function createCustomUomAsync(abbreviation, uomdesc) {
  const uomData = {
    "abbreviation": abbreviation,
    "uomdesc": uomdesc
  };
  return (dispatch, getState) => {
    dispatch(customUomAsyncActionStart());
    return api.request(`customuom`, 'post', uomData)
    .then((data) => {
      dispatch(customUomCreateActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(customUomAsyncActionError('Unable to create customuom'));
      throw (err);
    });
  };
}
